import { Directive, ElementRef, HostListener } from '@angular/core';

/**
 * Money field: the value is prefilled (0, or an amount such as the balance due), so on
 * focus select everything and typing replaces it instead of forcing the user to
 * backspace. select() works on type=number where setSelectionRange does not; the
 * timeout lets the click that caused the focus finish before selecting.
 */
@Directive({
  selector: '[appMoney]',
  standalone: true,
})
export class MoneyInputDirective {
  constructor(private readonly el: ElementRef<HTMLInputElement>) {}

  @HostListener('focus')
  onFocus(): void {
    const input = this.el.nativeElement;
    setTimeout(() => { if (document.activeElement === input) input.select(); });
  }
}
